import React from 'react';
import styles from './NotFound.module.scss';

const NotFound = () => (
  <div className={styles.page}>
    <div className={styles.inner}>
      <p className={styles.code}>404</p>
      <h1 className={styles.heading}>Page not found.</h1>
      <p className={styles.body}>
        The page you're looking for isn't available right now. It may have been moved, removed, or the link may be incorrect.
      </p>
      <a href="/receivables/" className={styles.link}>
        ← Back to home
      </a>
    </div>
  </div>
);

export default NotFound;
